import React from 'react';
import PropTypes from 'prop-types';
import style from '@src/js/Style';
import Button from './Button';
import Translation from './Translation';
import AdaptiveTrait from '../../AdaptiveTrait';
import SkeletonText from '../Skeleton/SkeletonText';

export default class SpoilerTags extends React.Component {

    static EXPAND_BUTTON_WIDTH = 70;

    constructor(props) {

        super(props);

        this.state = {
            collapsed: !AdaptiveTrait.isMobile(),
            tags: null,
            hasExpandButton: null,
        };

        this.components = {
            container: React.createRef(),
        };
    }

    static get propTypes() {

        return {
            className: PropTypes.string,
            children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
        };
    }

    //------------------------------------------------------------------------------------------------------------------
    // INIT
    //------------------------------------------------------------------------------------------------------------------

    componentDidMount() {

        this.processingTags();
        
        this.update = this.update.bind(this);

        AdaptiveTrait.addResizeEvent(this.update);
        document.addEventListener('DOMContentUpdated', this.update);
    }

    componentWillUnmount() {

        AdaptiveTrait.removeResizeEvent(this.update);
        document.removeEventListener('DOMContentUpdated', this.update);
    }

    //------------------------------------------------------------------------------------------------------------------
    // ACTIONS
    //------------------------------------------------------------------------------------------------------------------

    update(e = null) {
        
        if (e?.detail?.target == null || e?.detail?.target.contains(this.components.container.current)) {

            this.state = {
                collapsed: !AdaptiveTrait.isMobile(),
                tags: null,
                hasExpandButton: null,
            };
    
            this.processingTags();
        }
    }

    processingTags() {

        /** nothing to do */
        if (!this.state.collapsed)
            return;

        const container = this.components.container.current;
        
        /** unknown error */
        if (container == undefined)
            return;

        /** tags already processed */
        if (this.state.tags != null)
            return;

        /** create temp container and "show" at body */
        const tempContainer = container.cloneNode(true);
        tempContainer.style.visibility = 'hidden';
        document.body.appendChild(tempContainer);

        let
            hasExpandButton = false,
            offset = 0;
        const tags = Array
            .from(this.props.children)
            .map((tag) => {

                offset+= 124 + 8 + SpoilerTags.EXPAND_BUTTON_WIDTH;
                const isHidden = (offset > container.offsetWidth); // not error, use container

                if (isHidden)
                    hasExpandButton = true;

                return { offset, isHidden };
            });

        /** remove temp container */
        tempContainer.remove();

        this.setState({ tags, hasExpandButton });
    }

    expand() {

        this.setState({ collapsed: false, hasExpandButton: false });
    }

    //------------------------------------------------------------------------------------------------------------------
    // RENDER
    //------------------------------------------------------------------------------------------------------------------

    render() {

        if (!this.props.children)
            return null;

        const classes = [style('flex gap-md w-full')];
        if (this.props.className != undefined)
            classes.push(this.props.className);

        if (!this.state.collapsed)
            classes.push(style('flex-wrap'));

        const styles = {};
        if (this.state.collapsed && this.state.tags == null) {

            styles.position = 'absolute';
            styles.left = 0;
            styles.top = 0;
            styles.width = '100%';
            styles.zIndex = '-1';
            styles.visibility = 'hidden';
        }

        return (
            <div className={ style('relative w-full') }>
                <div className={ classes.join(' ') } ref={ this.components.container } style={ styles }>
                    { this.renderChildren() }
                    { this.renderExpandButton() }
                </div>
                {
                    (this.state.collapsed && this.state.tags == null)
                        ? <SkeletonText skeletonGroupClassName={ this.props.className } size={ '100%' } />
                        : null
                }
            </div>
        );
    }

    renderChildren() {

        if (!this.state.collapsed || !this.state.hasExpandButton)
            return this.props.children;

        return this.props.children.map((tag, index) => {

            return (this.state.tags && this.state.tags[index]?.isHidden)
                ? null
                : tag;
        });
    }

    renderExpandButton() {

        if (!this.state.hasExpandButton)
            return null; 

        return <Button
            className={ style('button-secondary text-small text-normal px-4 py-2') }
            onClick={ () => this.expand() }
            children={ <Translation tag='aggregation.btn.more' /> }
            />;
    }

}